import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import yup from '../../libs/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../components/form/TextInput';
import Swal from 'sweetalert2';
import { createClosingSchedule } from '../../api/sportaloka-client';
import { AxiosError } from 'axios';

const defaultValues = {
  name: '',
  start_at: '',
  end_at: ''
};

const schema = yup.object().shape({
  name: yup.string().label('Judul').required('${label} wajib diisi'),
  start_at: yup.string().label('Tanggal Mulai').required('${label} wajib dipilih'),
  end_at: yup.string().label('Tanggal Berakhir').required('${label} wajib dipilih')
});

const CreateClosingSchedule = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const form = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await createClosingSchedule(val);
      navigate('/closing-schedule');
      Swal.fire({
        title: 'Berhasil!',
        text: `Jadwal tutup berhasil dibuat`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    } catch (error) {
      let message = 'Periksa koneksi internet anda dan coba kembali';

      if (error instanceof AxiosError && error.response.data.code === '100801') {
        message = 'Periode termasuk dalam periode yang sudah ada.';
      }

      if (error instanceof AxiosError && error.response.data.code === '100802') {
        message = 'Tanggal mulai tidak boleh lebih besar dari tanggal berakhir';
      }

      Swal.fire({
        title: 'Gagal!',
        text: message,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-30 lh-14 fw-600">Buat Jadwal Tutup</h1>
            <div className="d-flex">
              <Link to="/closing-schedule" className="button -md bg-white h-50 text-dark mr-20">
                <i className="fa fa-arrow-left mr-10" />
                Kembali
              </Link>

              <button disabled={loading} className="button -md bg-blue-1 h-50 text-white">
                {!loading && <i className="fa fa-save text-16 mr-10" />}
                {loading ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </div>
          <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
            <div className="row">
              <div className="col-12">
                <Controller
                  control={form.control}
                  name="name"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <TextInput
                      disabled={loading}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="text"
                      isRequired={true}
                      label="Judul"
                      isError={Boolean(form.formState.errors.name)}
                      errorMessage={
                        Boolean(form.formState.errors.name) && form.formState.errors.name.message
                      }
                    />
                  )}
                />
              </div>
              <div className="col-6">
                <Controller
                  control={form.control}
                  name="start_at"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <TextInput
                      disabled={loading}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="date"
                      isRequired={true}
                      label="Tanggal Mulai"
                      isError={Boolean(form.formState.errors.start_at)}
                      errorMessage={
                        Boolean(form.formState.errors.start_at) &&
                        form.formState.errors.start_at.message
                      }
                    />
                  )}
                />
              </div>
              <div className="col-6">
                <Controller
                  control={form.control}
                  name="end_at"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <TextInput
                      disabled={loading}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="date"
                      isRequired={true}
                      label="Tanggal Berakhir"
                      isError={Boolean(form.formState.errors.end_at)}
                      errorMessage={
                        Boolean(form.formState.errors.end_at) &&
                        form.formState.errors.end_at.message
                      }
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CreateClosingSchedule;
